import { Affix, Button, Group, Paper, Text, Transition } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { applyUpdate, useUpdateReady } from '@web/lib/pwaUpdate';

/** "A new version is available" — shown when an update arrives while the page is open. */
export function UpdateNotice() {
  const { t } = useTranslation();
  const ready = useUpdateReady();
  return (
    <Affix position={{ bottom: 20, left: '50%' }} style={{ transform: 'translateX(-50%)' }} zIndex={400}>
      <Transition mounted={ready} transition="slide-up">
        {(styles) => (
          <Paper style={styles} shadow="lg" radius="md" withBorder px="md" py="sm" role="status">
            <Group gap="md" wrap="nowrap">
              <Text size="sm" fw={600}>
                {t('common:app.updateAvailable')}
              </Text>
              <Button size="xs" leftSection={<IconRefresh size={14} aria-hidden />} onClick={applyUpdate}>
                {t('common:app.updateNow')}
              </Button>
            </Group>
          </Paper>
        )}
      </Transition>
    </Affix>
  );
}
